// import {Pipe, PipeTransform} from '@angular/core';

// @Pipe({name: 'filterName'})
// export class FilterNamePipe implements PipeTransform {
//   transform(lista: any[], filtro: string = ''): any[] {
//     if (!filtro.trim()) return lista;
//     return lista.filter(x =>
//       x.name.toLowerCase().includes(filtro.toLowerCase()),
//     );
//   }
// }
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'filterName',
})
export class FilterNamePipe implements PipeTransform {
  transform(lista: any[], filtro: string): any[] {
    // Se não tem lista, retorna vazio
    if (!lista) return [];

    // Se não tem filtro ou filtro vazio, retorna a lista original
    if (!filtro || filtro.trim() === '') return lista;

    const termo = filtro.toLowerCase().trim();

    return lista.filter(item => item.name?.toLowerCase().includes(termo));
  }
}
